import {CircularProgress, Skeleton} from "@mui/material";
import React, {useEffect, useState} from "react";
import {getRandomInt} from "../utils/General";

const randomQuotes = [
  "Nothing is impossible. The word itself says 'I'm possible!' — Audrey Hepburn",
  "The bad news is time flies. The good news is you're the pilot. — Michael Altshuler",
  "Life was always a matter of waiting for the right moment to act. - Paulo Coelho",
  "Patience is not simply the ability to wait - it's how we behave while we're waiting. - Joyce Meyer",
  "Somewhere, something incredible is waiting to be known. - Sharon Begley",
  "This story has been yours all along. You just didn't know it. - Lylla",
];
const Fetching = ({title}) => {
  const [random, setRandom] = useState(-1);
  useEffect(() => {
    let randNum = getRandomInt(0, randomQuotes.length - 1);
    setRandom(randNum);
  }, []);
  return (
    <div className="fetching">
      <div className="fetch-content">
        <Skeleton variant="rectangular" width={340} height={"100vh"} />
        <div className="fetch-col">
          <Skeleton variant="rectangular" width={"100%"} height={60} />
          <div className="hint-box">
            <h4> {title} </h4>
            <CircularProgress color="inherit" />
            <p> "{randomQuotes[random]}" </p>
          </div>
          <div className="fetch-block">
            <Skeleton variant="text" width={"30%"} sx={{fontSize: "1.8rem"}} />
            <Skeleton variant="rounded" width={"100%"} height={250} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fetching;
